module.exports = __webpack_public_path__ + "static/img/serpentlogo.44a805e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serpentlogo.jpg
// module id = w9Ev
// module chunks = 0